import React, { useState, useEffect } from 'react';
import {ReactComponent as ReactLogo_en} from '../images/svgLatest/loadingGPTIcon_en.svg';
import {ReactComponent as ReactLogo_fr} from '../images/svgLatest/loadingGPTIcon_fr.svg';
import {ReactComponent as ReactLogo_de} from '../images/svgLatest/loadingGPTIcon_de.svg';
import {ReactComponent as ReactLogo_it} from '../images/svgLatest/loadingGPTIcon_it.svg';
import {ReactComponent as ReactLogo_es} from '../images/svgLatest/loadingGPTIcon_es.svg';
import {ReactComponent as ReactLogo_nl} from '../images/svgLatest/loadingGPTIcon_nl.svg';
import {ReactComponent as ReactLogo_fr_ca} from '../images/svgLatest/loadingGPTIcon_fr-ca.svg';
import {ReactComponent as ReactLogo_cs} from '../images/svgLatest/loadingGPTIcon_cs.svg';
import {ReactComponent as ReactLogoNew} from '../images/svgBranding/loadingGPTIcon.svg';
import StaticLabels from "../util/staticLabels.json";
const LoadingComponent = ({content}) => {
    const [dotIndex, setDotIndex] = useState(0);
    const length = 4;
    const languageCode = (window.config.language || "en").toLowerCase();
    const loadingIconByLanguage = {
        en: ReactLogo_en,
        fr: ReactLogo_fr,
        "fr-ca": ReactLogo_fr_ca,
        de: ReactLogo_de,
        it: ReactLogo_it,
        es: ReactLogo_es,
        nl: ReactLogo_nl,
        cs: ReactLogo_cs,
        cz: ReactLogo_cs
    };
    const SelectedLogo = loadingIconByLanguage[languageCode] || loadingIconByLanguage[languageCode.split("-")[0]] || ReactLogo_en;
    // Dot animation
    useEffect(() => {
        const interval = setInterval(() => {
            setDotIndex((prevIndex) => (prevIndex + 1) % length);
        }, 500); 

        return () => clearInterval(interval);
    }, []);

    return (
    window.config.progressIndicationName==content?<div className="loadingDiv">
             {window.config.isGlobalDomainUI ? <><ReactLogoNew className="loadingDivImage"/><span className="searchingCenter">{StaticLabels[window.config.language].searchingCenter}</span></> : 
             <SelectedLogo className="loadingDivImage"/>}
            <div className="dotsContainer">
                {/* Create dots based on dotIndex */}
                {Array.from({ length }, (_, i) => (
                    <span key={i} className={`dot ${dotIndex === i ? 'active' : ''}`}>
                        •
                    </span>
                ))}
            </div>
       </div>:null
    );
};

export default LoadingComponent;